import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Typed from 'react-typed';
import 'react-typed/dist/animatedCursor.css';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <div>
    <h3>Hi! I'm Yunus!</h3>
    <p>
        I'm a developer.
        I love to make beautiful and well-coded applications.
        Also, I interested in compiler and interpreters.
        I will be writing topics like
        
        {' '}
        
        <Typed strings={['React.', 'JS.', 'Rails.', 'Stimulus.', 'Ruby.', 'Flutter.', 'Go.', 'Android.']} typeSpeed={65} backSpeed={55} loop mdxType="Typed">
            <p style={{
            display: 'inline'
          }}></p>
        </Typed>
    </p>
    </div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      